// export default {
//     install(Vue, options) {
//         Vue.prototype.$confirm = function () {

//         }
//     }
// }

import { App } from "vue";

export interface Dialova {
  callBack: (options: any) => any;
}

export default {
  install: async (app: App, options: { components: Record<string, any> }) => {
    let callBack = null;
    await app.mixin({
      beforeCreate() {
        if (this.$options.name == "DIALOVA_DIALOG_COMPONENT")
          this.$options.components = options.components || {};
      },
      created() {
        if (this.$options.name == "DIALOVA_DIALOG_COMPONENT")
          callBack = this.openDialog;
      },
    });

    if(callBack)
      app.config.globalProperties.$dialova = callBack;
  },
};

declare module "@vue/runtime-core" {
  //Bind to `this` keyword
  interface ComponentCustomProperties {
    $dialova: Dialova;
  }
}
